





















import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import {namespace} from 'vuex-class';
import {ReviewRate} from '@/store/RateReviewFaq/types';
import BIcon from 'buefy/src/components/icon/Icon.vue';
import BInput from 'buefy/src/components/input/Input.vue';
import BLoading from 'buefy/src/components/loading/Loading.vue';
import BField from 'buefy/src/components/field/Field.vue';
import {MAFUser} from '@/store/User/types';
import {DateTime} from 'luxon';

/* tslint:disable:no-empty */

@Component({
    components: {BButton,
    },
})
export default class PurchaseCoinsBody extends Vue {
  public purchaseOptions: any[];
  constructor() {
        super();
        this.purchaseOptions = [
            { coins: 10,    price: 5.00 },
            { coins: 20,    price: 10.00 },
            { coins: 50,    price: 20.00 },
        ];
    }
    @Emit('payment')
    public payment(option: any) {
        return option;
    }

    @Emit('close')
    public close() {
    }
}
